module.exports = __webpack_public_path__ + "img/firstp.a9de1b88.png";